import { render, staticRenderFns } from "./DialogImageInput.vue?vue&type=template&id=5819e407&"
import script from "./DialogImageInput.vue?vue&type=script&lang=js&"
export * from "./DialogImageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports